import React from "react";
import { Thead, Tr, Th } from "react-super-responsive-table";

export default function THeadings() {
  return (
    <Thead>
      <Tr>
        <Th>Date</Th>
        <Th># Cases</Th>
        <Th>New Cases</Th>
        <Th>Rate 100k Cases</Th>
        <Th># Deaths</Th>
        <Th>New Deaths</Th>
        <Th>Rate 100k Deaths</Th>
      </Tr>
    </Thead>
  );
}
